import TOKENS from "../../tokens/tokens";
import { DION_SCROLLBAR } from "./scroll-bar";
const CALENDAR_THEME_OVERRIDES = {
  MuiPickersLayout: {
    styleOverrides: {
      root: {
        backgroundColor: "var(--mui-palette-elevation2-main)",
        marginTop: "8px",
        ".MuiDialogActions-root .MuiButtonBase-root": {
          width: "100%",
          color: "var(--mui-palette-brand-contrast)",
          backgroundColor: "var(--mui-palette-brand-main)",
          borderRadius: TOKENS.radius[8],
          "&:hover": {
            // background:'transparent'
          }
        }
      }
    }
  },
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        ".MuiStack-root .MuiButtonBase-root": {
          ...TOKENS.typography.body1
        },
        backgroundColor: "var(--mui-palette-elevation2-main)",
        borderRadius: TOKENS.radius[8],
        border: "0px",
        padding: "16px 0px",
        width: "284px",
        height: "310px"
      }
    }
  },
  MuiDayCalendar: {
    styleOverrides: {
      root: {
        marginTop: "10px",
        ".MuiDayCalendar-slideTransition": {
          minHeight: "210px"
        }
      },
      weekDayLabel: {
        ...TOKENS.typography.body2,
        color: "var(--mui-palette-elevation1-contrast)",
        margin: "0px 3px",
        width: "32px",
        height: "32px"
      },
      weekContainer: {
        ".MuiPickersDay-root": {
          ...TOKENS.typography.body2,
          color: "var(--mui-palette-elevation1-contrast)",
          margin: "0px 3px",
          borderRadius: TOKENS.radius[8],
          width: "32px",
          height: "32px",
          "&.MuiPickersDay-today": {
            border: "0px",
            outline: "1px solid var(--mui-palette-lines-borderAccent)",
            backgroundColor: "transparent"
          },
          "&.MuiButtonBase-root.Mui-selected": {
            outline: "1px solid var(--mui-palette-brand-main)",
            backgroundColor: "var(--mui-palette-brand-main)",
            color: "var(--mui-palette-elevation1-contrast)",
            "&:hover": {
              backgroundColor: "transparent"
            }
          },
          "&:hover": {
            backgroundColor: "transparent",
            outline: "1px solid var(--mui-palette-brand-main)"
          },
          "&.MuiPickersDay-dayOutsideMonth": {
            color: "var(--mui-palette-elevation2-disableText)"
          }
        }
      }
    }
  },
  MuiMonthCalendar: {
    styleOverrides: {
      root: {
        marginTop: "10px",
        paddingTop: "40px",
        width: "284px",
        borderTop: "1px solid var(--mui-palette-lines-divider)",
        ".MuiPickersMonth-root": {
          width: "25%",
          flexBasis: "25%"
        },
        ".MuiPickersMonth-monthButton": {
          ...TOKENS.typography.body2,
          color: "var(--mui-palette-elevation1-contrast)",
          border: "0px",
          outline: "1px solid transparent",
          borderRadius: TOKENS.radius[8],
          "&.MuiPickersMonth-today": {
            border: "0px",
            outline: "1px solid var(--mui-palette-lines-borderAccent)",
            backgroundColor: "transparent"
          },
          "&.MuiPickersMonth-monthButton.Mui-selected": {
            border: "0px",
            outline: "1px solid var(--mui-palette-lines-borderAccent)",
            backgroundColor: "transparent",
            color: "var(--mui-palette-elevation1-contrast)"
          },
          "&:hover": {
            backgroundColor: "transparent",
            outline: "1px solid var(--mui-palette-brand-main)"
          },
          "&:focus": {
            outline: "1px solid var(--mui-palette-brand-main)",
            backgroundColor: "transparent"
          }
        }
      }
    }
  },
  MuiYearCalendar: {
    styleOverrides: {
      root: {
        ...DION_SCROLLBAR,
        borderTop: "1px solid var(--mui-palette-lines-divider)",
        marginTop: "10px",
        width: "284px",
        ".MuiPickersYear-root": {
          width: "25%"
        },
        ".MuiPickersYear-yearButton": {
          ...TOKENS.typography.body2,
          borderRadius: TOKENS.radius[8],
          color: "var(--mui-palette-elevation1-contrast)",
          border: 0,
          outline: "1px solid transparent",
          "&.MuiPickersYear-yearButton.Mui-selected": {
            border: 0,
            outline: "1px solid var(--mui-palette-lines-borderAccent)",
            backgroundColor: "transparent",
            color: "var(--mui-palette-elevation1-contrast)",
            "&:hover": {
              backgroundColor: "transparent"
            }
          },
          "&:hover": {
            backgroundColor: "transparent",
            outline: "1px solid var(--mui-palette-brand-main)"
          },
          "&:focus": {
            outline: "1px solid var(--mui-palette-brand-main)",
            backgroundColor: "transparent"
          }
        }
      }
    }
  },
  MuiMultiSectionDigitalClock: {
    styleOverrides: {
      root: {
        ".MuiMultiSectionDigitalClock-root": {
          ...DION_SCROLLBAR,
          width: "48px",
          "&::after": {
            display: "none"
          },
          ".MuiButtonBase-root": {
            width: "32px",
            height: "32px",
            borderRadius: TOKENS.radius[8],
            "&:hover": {
              outline: "1px solid var(--mui-palette-brand-main)",
              background: "transparent"
            },
            "&.Mui-selected": {
              backgroundColor: "var(--mui-palette-brand-main)",
              color: "var(--mui-palette-elevation1-contrast)",
              "&:hover": {
                backgroundColor: "transparent"
              }
            }
          }
        }
      }
    }
  }
};
export {
  CALENDAR_THEME_OVERRIDES
};
